import { analytics } from "../firebase-config";
import { logEvent } from "firebase/analytics";

export const CMS_EVENTS = {
  // Dashboard
  DASHBOARD_VIEW: "dashboard_view",

  // Appointments
  APPOINTMENT_CREATED: "appointment_created",
  APPOINTMENT_UPDATED: "appointment_updated",
  APPOINTMENT_VIEWED: "appointment_viewed",
  APPOINTMENT_DELETED: "appointment_deleted",

  // Employees
  EMPLOYEE_ADDED: "employee_added",
  EMPLOYEE_UPDATED: "employee_updated",
  EMPLOYEE_VIEWED: "employee_viewed",
  EMPLOYEE_DELETED: "employee_deleted",

  // Clients
  CLIENT_ADDED: "client_added",
  CLIENT_UPDATED: "client_updated",
  CLIENT_VIEWED: "client_viewed",
  CLIENT_DELETED: "client_deleted",

  // Issues
  ISSUE_CREATED: "issue_created",
  ISSUE_UPDATED: "issue_updated",
  ISSUE_VIEWED: "issue_viewed",
  ISSUE_ESCALATED: "issue_escalated",
  ISSUE_CLOSED: "issue_closed",

  // Supplies
  SUPPLY_REQUEST_CREATED: "supply_request_created",
  SUPPLY_REQUEST_UPDATED: "supply_request_updated",
  SUPPLY_REQUEST_VIEWED: "supply_request_viewed",

  // Profile
  PROFILE_UPDATED: "profile_updated",

  // SuperUser
  SUPERUSER_CREATED: "superuser_created",
  SUPERUSER_UPDATED: "superuser_updated",
  SUPERUSER_DELETED: "superuser_deleted",
  SUPERUSER_VIEWED: "superuser_viewed",
  COMPANY_CREATED: "company_created",
  COMPANY_UPDATED: "company_updated",
  COMPANY_DELETED: "company_deleted",
  ADMIN_CREATED: "admin_created",
  ADMIN_UPDATED: "admin_updated",
  ADMIN_DELETED: "admin_deleted",

  // Reports
  REPORT_DOWNLOADED: "report_downloaded",
  REPORT_EMAILED: "report_emailed",
  REPORT_VIEWED: "report_viewed",

  // Stripe Payments
  PAYMENT_SUCCESS: "payment_success",
  PAYMENT_FAILED: "payment_failed",
  SUBSCRIPTION_CHANGED: "subscription_changed",

  // Admin Settings
  SETTINGS_UPDATED: "settings_updated",

  // Help & Support
  HELP_OPENED: "help_opened",
  CONTACT_SUPPORT: "contact_support",
  SUPPORT_TICKET_CREATED: "support_ticket_created",
  SUPPORT_TICKET_OPENED: "support_ticket_opened",
  SUPPORT_TICKET_VIEWED: "support_ticket_viewed",

  // Notifications
  NOTIFICATION_RECEIVED: "notification_received",
  NOTIFICATION_CLICKED: "notification_clicked",
  NOTIFICATION_VIEWED: "notification_viewed",
  NOTIFICATION_CREATED: "notification_created",

  // Live Chat
  LIVE_CHAT_STARTED: "live_chat_started",
  LIVE_CHAT_MESSAGE_SENT: "live_chat_message_sent",

  // Authentication
  USER_LOGIN: "user_login",
  USER_REGISTER: "user_register",
  FORGOT_PASSWORD_REQUEST: "forgot_password_request",
  LOGIN_SUCCESS: "login_success",
  LOGIN_FAILED: "login_failed",

  // Groups & Channels
  GROUP_CREATED: "group_created",
  GROUP_UPDATED: "group_updated",
  GROUP_DELETED: "group_deleted",
  GROUP_VIEWED: "group_viewed",
  CHANNEL_CREATED: "channel_created",
  CHANNEL_UPDATED: "channel_updated",
  CHANNEL_DELETED: "channel_deleted",
  PROOF_OF_WORK_VIEWED: "proof_of_work_viewed",
  PROOF_OF_SERVICE_VIEWED: "proof_of_service_viewed",
  PROOF_OF_SERVICE_SETTING_UPDATED: "proof_of_service_setting_updated",
};

export const TYPES = {
  // Dashboard
  DASHBOARD_VIEW: "dashboard",

  // Appointments
  APPOINTMENT_CREATED: "appointment",
  APPOINTMENT_UPDATED: "appointment",
  APPOINTMENT_VIEWED: "appointment",
  APPOINTMENT_DELETED: "appointment",

  // Employees
  EMPLOYEE_ADDED: "employee",
  EMPLOYEE_UPDATED: "employee",
  EMPLOYEE_VIEWED: "employee",
  EMPLOYEE_DELETED: "employee",

  // Clients
  CLIENT_ADDED: "client",
  CLIENT_UPDATED: "client",
  CLIENT_VIEWED: "client",
  CLIENT_DELETED: "client",

  // Issues
  ISSUE_CREATED: "issue",
  ISSUE_UPDATED: "issue",
  ISSUE_VIEWED: "issue",
  ISSUE_ESCALATED: "issue",
  ISSUE_CLOSED: "issue",

  // Support
  SUPPORT_TICKET_CREATED: "support",
  SUPPORT_TICKET_OPENED: "support",
  SUPPORT_TICKET_VIEWED: "support",

  // Supplies
  SUPPLY_REQUEST_CREATED: "supply",
  SUPPLY_REQUEST_UPDATED: "supply",
  SUPPLY_REQUEST_VIEWED: "supply",

  // Profile
  PROFILE_UPDATED: "profile",

  // SuperUser
  SUPERUSER_CREATED: "superuser",
  SUPERUSER_UPDATED: "superuser",
  SUPERUSER_DELETED: "superuser",
  SUPERUSER_VIEWED: "superuser",
  COMPANY_CREATED: "superuser",
  COMPANY_UPDATED: "superuser",
  COMPANY_DELETED: "superuser",
  ADMIN_CREATED: "superuser",
  ADMIN_UPDATED: "superuser",
  ADMIN_DELETED: "superuser",

  // Reports
  REPORT_DOWNLOADED: "report",
  REPORT_EMAILED: "report",
  REPORT_VIEWED: "report",

  // Stripe Payments
  PAYMENT_SUCCESS: "payment",
  PAYMENT_FAILED: "payment",
  SUBSCRIPTION_CHANGED: "subscription",

  // Admin Settings
  SETTINGS_UPDATED: "settings",

  // Help
  HELP_OPENED: "help",
  CONTACT_SUPPORT: "help",

  // Notifications
  NOTIFICATION_RECEIVED: "notification",
  NOTIFICATION_CLICKED: "notification",
  NOTIFICATION_VIEWED: "notification",
  NOTIFICATION_CREATED: "notification",

  // Live Chat
  LIVE_CHAT_STARTED: "livechat",
  LIVE_CHAT_MESSAGE_SENT: "livechat",

  // Authentication
  USER_LOGIN: "auth",
  USER_REGISTER: "auth",
  FORGOT_PASSWORD_REQUEST: "auth",
  LOGIN_SUCCESS: "auth",
  LOGIN_FAILED: "auth",

  // Groups & Channels
  GROUP_CREATED: "group",
  GROUP_UPDATED: "group",
  GROUP_DELETED: "group",
  GROUP_VIEWED: "group",
  CHANNEL_CREATED: "channel",
  CHANNEL_UPDATED: "channel",
  CHANNEL_DELETED: "channel",
  PROOF_OF_WORK_VIEWED: "scheduler",
  PROOF_OF_SERVICE_VIEWED: "scheduler",
  PROOF_OF_SERVICE_SETTING_UPDATED: "settings",
};

export const trackEvent = async (eventName, params = {}) => {
  try {
    if (!analytics) return;

    logEvent(analytics, eventName, {
      ...params,
      type: TYPES[eventName],
      platform: "cms",
      timestamp: Date.now()
    });
  } catch (error) {
    console.error("Analytics error:", error);
  }
};

export const trackPageView = (pageName) => {
  if (!analytics) return;

  logEvent(analytics, "webPage_view", {
    page_name: pageName,
    platform: "cms",
  });
};